module.exports = __webpack_public_path__ + "static/media/warning_Gold_24dp.76859345.svg";